module.exports = __webpack_public_path__ + "img/sleeping-bot-avatar.2179aa10.png";